import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';

const ResourcesPage = () => {
  const newsItems = [
    { date: 'February 4, 2026', title: 'Archon Insurance Supports Local Massachusetts Charities', link: '#' },
    { date: 'January 15, 2026', title: 'Understanding Your Business Insurance Needs in 2026', link: '#' },
    { date: 'December 10, 2025', title: 'Year-End Insurance Review: What Massachusetts Businesses Should Know', link: '#' },
  ];

  const whitepapers = [
    { title: 'What is a GIA or General Indemnity Agreement? Why do my spouse and I both have to sign?', link: '#' },
    { title: 'Tips And Techniques: Dealing With Subcontractors And Certificates Of Insurance', link: '#' },
    { title: 'The Hot Potato of Indemnification – What\'s being asked of you and why?', link: '#' },
    { title: 'The Effects of Recent Market Changes on the Insurance Industry', link: '#' },
    { title: 'State of the Massachusetts Insurance Marketplace', link: '#' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Page Banner */}
      <div className="page-banner">
        <div className="container-wide">
          <h1>RESOURCES</h1>
          <div className="breadcrumb">
            <Link to="/">Home</Link> &gt; Resources
          </div>
        </div>
      </div>

      {/* Content */}
      <section className="content-section" data-testid="resources-content">
        <div className="container-narrow">
          
          <h2>Resources</h2>
          <p>
            Stay informed with the latest news, educational materials, and industry insights 
            from Archon Insurance.
          </p>

          <hr className="content-divider" />

          {/* News */}
          <h2>News</h2>
          <div className="mt-4">
            <Link to="#" className="text-[#1a365d] font-semibold text-sm uppercase tracking-wide hover:text-[var(--gold)]">
              More News →
            </Link>
          </div>

          <hr className="content-divider" />

          {/* Events */}
          <h2>Events</h2>
          <p className="italic text-gray-500">No upcoming events scheduled at this time.</p>
          <div className="mt-4">
            <Link to="#" className="text-[#1a365d] font-semibold text-sm uppercase tracking-wide hover:text-[var(--gold)]">
              All Events →
            </Link>
          </div>

          <hr className="content-divider" />

          {/* Podcasts */}
          <div className="mt-4">
            <Link to="#" className="text-[#1a365d] font-semibold text-sm uppercase tracking-wide hover:text-[var(--gold)]">
              Podcasts →
            </Link>
          </div>

          <hr className="content-divider" />

          {/* Newsletter */}
          <div className="mt-4">
            <Link to="#" className="text-[#1a365d] font-semibold text-sm uppercase tracking-wide hover:text-[var(--gold)]">
              Email Newsletter Archive →
            </Link>
          </div>

          <hr className="content-divider" />

          {/* White Papers */}
          <h2>White Papers</h2>
          <ul className="space-y-3">
            {whitepapers.map((paper, index) => (
              <li key={index} className="flex items-start gap-2">
                <span className="text-[var(--gold)]">•</span>
                <Link to={paper.link} className="text-[#1a365d] hover:text-[var(--gold)]">
                  {paper.title}
                </Link>
              </li>
            ))}
          </ul>
          <div className="mt-4">
            <Link to="#" className="text-[#1a365d] font-semibold text-sm uppercase tracking-wide hover:text-[var(--gold)]">
              All White Papers →
            </Link>
          </div>

          <hr className="content-divider" />

          {/* CTA */}
          <div className="text-center py-8">
            <Link to="/claims" className="btn-navy">
              File a Claim
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ResourcesPage;
